import { ChangeDetectionStrategy, Component } from '@angular/core';
import {ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-auth-wrapper',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ReactiveFormsModule,
        TranslateModule
    ],
    templateUrl: './auth-wrapper.component.html',
    styleUrl: './auth-wrapper.component.scss'
})
export class AuthWrapperComponent {

}
